let disableCopyPasteDirective = (SetupService, User) => {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: (scope, element, attrs, controller) => {
            return SetupService.get(User.getUser().branchId)
                .then((data) => {
                    if (!data.disableCopyPaste) return;
                    element.on('copy', (event) => {
                        event.preventDefault();
                        // alert('Copy is not allowed!');
                    });

                    element.on('paste', (event) => {
                        event.preventDefault();
                        // alert('Paste is not allowed!');
                    });
                })
                .catch(err => {
                    console.log(err);
                })
        }
    }
}

disableCopyPasteDirective.$inject = ['SetupService', 'User'];

export default disableCopyPasteDirective;


// WEBPACK FOOTER //
// ./client/app/common/disable-copy-paste/disable-copy-paste.directive.js